import { gql } from '@apollo/client';
/**
 * @fragment TagFragment
 * @since 1.0.0
 */
export const TagFragment = gql `
  fragment TagFragment on Tag {
    id
    entity
    name
    color
    position
  }
`;
